import script from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavbar.vue?vue&type=script&setup=true&lang=js"

import "./AppNavbar.vue?vue&type=style&index=0&id=d9ba0024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ba0024"]])

export default __exports__